/* ============================================================
   Home Hero Banner + Trust Bar
   Vanilla JS, no dependencies.

   The <home-hero-banner> custom element watches itself with an
   IntersectionObserver and adds the .hhb--visible class when it
   enters the viewport. All actual animation lives in CSS
   (transforms + opacity only).

   Defined as a custom element so it re-initializes automatically
   when the Theme Editor re-renders the section (no extra
   shopify:section:load wiring needed).
   ============================================================ */

(() => {
  'use strict';

  if (customElements.get('home-hero-banner')) return;

  class HomeHeroBanner extends HTMLElement {
    connectedCallback() {
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const isAnimated = this.classList.contains('hhb--animated');
      const supportsObserver = 'IntersectionObserver' in window;

      // No animation requested, reduced motion preferred, or no
      // observer support: show everything immediately.
      if (!isAnimated || prefersReducedMotion || !supportsObserver) {
        this.classList.add('hhb--visible');
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this.classList.add('hhb--visible');
            this._teardown();
            break;
          }
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -5% 0px'
        }
      );

      this._observer.observe(this);
    }

    disconnectedCallback() {
      this._teardown();
    }

    _teardown() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
  }

  customElements.define('home-hero-banner', HomeHeroBanner);
})();